import { FileSearch, RotateCcw, ShieldCheck } from 'lucide-react';

const icons = {
  FileSearch,
  RotateCcw,
  ShieldCheck,
};

export default function Security({ content }) {
  return (
    <section className="section section-security" id="security">
      <div className="section-inner split-section reverse">
        <div className="section-header">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2>{content.title}</h2>
          <p>{content.intro}</p>
        </div>

        <div className="trust-list">
          {content.items.map((item, index) => {
            const Icon = icons[item.icon];
            return (
              <article className="trust-item" key={item.title}>
                <span className="trust-index">{String(index + 1).padStart(2, '0')}</span>
                <span className="card-icon">
                  <Icon size={21} />
                </span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
